module.exports = __webpack_public_path__ + "static/img/chanta (6).9309d72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (6).jpg
// module id = g3DW
// module chunks = 0